export default class TextFieldRulesService {
  static requiredRule = (v: any) => !!v || 'Required field.';

  static emailRule = (v: any) => /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Invalid email.';

  static acceptedRule = (v: any) => v === true || 'Must be accepted to proceed.';
}
